import { TypeOf, yup } from '@guiker/yup-util'

export const pricePerUnitSchema = yup.object({
  amount: yup.number().required(),
  currency: yup.string().required(),
})

export type PricePerUnitSchema = TypeOf<typeof pricePerUnitSchema>
